// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"908":"f597ebb7","2445":"3b01b10d"}[chunkId] + ".chunk.css";
};